import androidx.compose.foundation.ComposeFoundationFlags
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.schoolconnect.app.App

@OptIn(ExperimentalComposeUiApi::class, ExperimentalFoundationApi::class)
fun main() {
    // Compose 1.12 added click-sound playback to clickable modifiers. On web,
    // a click can synchronously remove/recompose its DOM node before the
    // sound path reads LocalSoundEffect, which crashes with:
    // "Cannot read CompositionLocal because the Modifier node is not currently attached."
    // Web has no native Compose click sound, so disable this experimental path
    // before any Compose content is created. Keep it scoped to web; native
    // targets retain their normal interaction behavior.
    ComposeFoundationFlags.isInteractionSoundEffectOnClickEnabled = false

    if (!isBrowserWebGlAvailable()) {
        showBrowserStartupError()
        return
    }
    ComposeViewport { App() }
}
